import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

/**
 * Головна кнопка дії — ОДНА форма на весь застосунок (owner 2026-08-29:
 * «немає системи, скрізь все по-різному»).
 *
 * До цього повнорозмірні кнопки жили в кожному екрані окремо: десь
 * `rounded-ios-hero py-4`, десь `rounded-full py-3.5`, десь свій сірий для
 * неактивного стану. Тепер форма, кегль і поведінка задані тут.
 *
 * `tone`:
 *   primary   — основна дія (зберегти, оформити, підтвердити);
 *   secondary — другорядна дія поруч з основною (скасувати, пізніше).
 */

interface Props {
  children: ReactNode;
  onClick?: () => void;
  disabled?: boolean;
  tone?: "primary" | "secondary";
  type?: "button" | "submit";
  className?: string;
}

export function ActionButton({
  children,
  onClick,
  disabled = false,
  tone = "primary",
  type = "button",
  className,
}: Props) {
  return (
    <button
      type={type}
      disabled={disabled}
      onClick={onClick}
      className={cn(
        "flex w-full items-center justify-center gap-2 rounded-full px-5 py-3.5",
        "font-display text-[0.9375rem] font-bold leading-none transition",
        disabled
          ? // Неактивна — суцільний сірий, а НЕ вицвіла помаранчева: вона
            // читалась як зламана (owner 2026-08-24).
            "bg-ink/[0.07] text-ink-faint"
          : tone === "primary"
            ? "bg-primary text-white active:bg-primary-deep"
            : "bg-ink/[0.06] text-ink active:bg-ink/[0.1]",
        className,
      )}
    >
      {children}
    </button>
  );
}
